<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import axios from "axios";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";
// Lets Register a Global Error Notification Toast.
/**
 * Departamento component
 */
 import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

export default {
  page: {
    title: "Información de la cotizacion",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vuetable },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      stock: [],
      url: 0,
      formPro: {
        user: "",
        fecha_venta: "",
        fecha_vencimiento: "",
        direccionp: "",
        empleado: "",
        nit_proveedor: "",
        observaciones: "",
        no_orden: "",
        fecha_compra: "",
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        id: 0,
      },
      detalleProducto: [],
      detalleServicio: [],
      fields: [
        {
          name: "stock.producto.nombre_producto",
          sortField: "stock.producto.nombre_producto",
          title: "Nombre",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "stock.presentacione.nombre_presentacion",
          sortField: "presentaciones",
          title: "Presentación",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "cantidad_venta",
          sortField: "cantidad_venta",
          title: "Cantidad",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "precio_compra",
          sortField: "precio_compra",
          title: "Precio venta",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "porcentaje",
          sortField: "porcentaje",
          title: "Porcentaje de descuento",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "subtotal",
          sortField: "subtotal",
          title: "Subtotal",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          //   width: "20%",
        },
      ],
      fields2: [
        {
          name: "servicio.nombre_servicio",
          sortField: "servicio.nombre_servicio",
          title: "Nombre",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "servicio.descripcion_servicio",
          sortField: "servicio.descripcion_servicio",
          title: "Descripción",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "cantidad_servicios",
          sortField: "cantidad_servicios",
          title: "Cantidad",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "precio_servicio",
          sortField: "precio_cservicio",
          title: "Precio",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },

        {
          name: "subtotal",
          sortField: "subtotal",
          title: "Subtotal",
          titleClass: "",
          dataClass: "list-item-heading",
          //   width: "25%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          //   width: "20%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Venta",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date)
        .locale("es")
        .utc()
        .format("MMM Do YYYY");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "ventas/view_venta?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          // console.log("response", response);
          me.detalleProducto = response.data.orden.detalle_ventas;
          me.detalleServicio = response.data.orden.detalle_servicio_vs;
          // console.log(this.detalleProducto);
          // console.log(this.detalleServicio);
          me.formPro.proveedor =
            response.data.orden.cliente_rapido != ""
              ? response.data.orden.cliente_rapido
              : response.data.orden.cliente.persona.nombre_persona;
          me.formPro.no_orden = response.data.orden.no_venta;
          me.formPro.observaciones = response.data.orden.observaciones;
          me.formPro.fecha_venta = response.data.orden.fecha_venta;
          me.formPro.total = response.data.orden.total;
          me.formPro.direccionp = "Guatemala";
          me.formPro.state = response.data.orden.estado_venta;
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->

        <!-- Modal para Desactivar -->
        <!--             <b-modal
              centered
              v-model="showModalD"
              title="Desactivar"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                         <h4>¿Desea Desactivar  {{this.formSub.nombre}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalD = false">Cancelar</b-button>
                         <b-button variant="danger" @click="desactivate">Desactivar</b-button>
                      </div>
                    </form>
            </b-modal>
 -->

        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div class="text-center">
                    <div class="mb-4"></div>

                    <h4>INFORMACIÓN DE LA VENTA</h4>
                    <br />
                    <router-link
                      :to="{
                        name: 'ventas',
                      }"
                    >
                      <b-button
                        variant="outline-primary"
                        type="button"
                        class="btn btn-rounded mb-2 me-2"
                      >
                        <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b
                          >REGRESAR</b
                        >
                      </b-button>
                    </router-link>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col" align="center">
                      Fecha de venta:
                      <a href="#" class="badge bg-dark font-size-12">
                        {{ showDate(formPro.fecha_venta) }}
                      </a>
                    </div>
                  </div>
                  <br />
                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2">Dirección</p>
                          <h5 class="font-size-15">{{ formPro.direccionp }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2">Observaciones</p>
                          <h5 class="font-size-15">
                            {{
                              formPro.observaciones == ""
                                ? "Sin observaciones"
                                : formPro.observaciones
                            }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Estado</p>
                          <h5 v-if="formPro.state == true">
                            <span class="badge bg-success ms-1"
                              ><strong>ACTIVO</strong></span
                            >
                          </h5>
                          <h5 v-else>
                            <span class="badge bg-danger ms-1"
                              ><strong>INACTIVO</strong></span
                            >
                          </h5>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col">
                        <div>
                          <p class="text-muted mb-2">Cliente</p>
                          <h5 class="font-size-15">
                            {{
                              formPro.proveedor != null
                                ? formPro.proveedor
                                : "Sin cliente asignado"
                            }}
                          </h5>
                        </div>
                      </div>
                      <div class="col">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">No. Cotización</p>
                          <h5 class="font-size-15">{{ formPro.no_orden }}</h5>
                        </div>
                      </div>
                      <div class="col">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Total</p>
                          <h5 class="font-size-15">
                            {{ money(formPro.total > 0 ? formPro.total : 0.0) }}
                          </h5>
                        </div>
                      </div>
                      <!-- <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Usuario</p>
                          <h6 v-if="formPro.user != ''" class="font-size-15">
                            {{ formPro.user }}
                          </h6>
                          <h6 v-else class="font-size-15">Sin autorizar</h6>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="detalleProducto.length > 0">
          <div class="card-body">
            <h4 class="card-title">Listado de productos</h4>
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="detalleProducto"
              >
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_detalle == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="subtotal" slot-scope="props">
                  {{ money(props.rowData.subtotal_venta) }}
                </div>
                <div slot="precio_compra" slot-scope="props">
                  {{ money(props.rowData.precio_venta) }}
                </div>
                <div slot="porcentaje" slot-scope="props">
                  {{ props.rowData.descuento_porcentaje + '%' }}
                </div>
              </vuetable>
            </Loader>
          </div>
        </div>
        <div class="card" v-if="detalleServicio.length > 0">
          <div class="card-body">
            <h4 class="card-title">Listado de servicios</h4>
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields2"
                :data="detalleServicio"
              >
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_detalle == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="subtotal" slot-scope="props">
                  {{ money(props.rowData.subtotal_servicio) }}
                </div>
                <div slot="precio_servicio" slot-scope="props">
                  {{ money(props.rowData.precio_servicio) }}
                </div>
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
